import React from 'react';

export default function GroupModal({ open, mode, data, subjects, onClose, onChange, onSave }) {
  if (!open) return null;

  const selected = data?.subject_ids || [];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
        <h4 className="text-lg font-semibold mb-2">{mode === 'edit' ? 'Edit' : 'Add'} Subject Group</h4>
        <div className="space-y-2">
          <input
            placeholder="group name"
            value={data?.name || ''}
            onChange={(e) => onChange({ ...data, name: e.target.value })}
            className="border rounded px-2 w-full"
          />
          <select
            multiple
            value={selected}
            onChange={(e) => {
              const options = Array.from(e.target.selectedOptions).map((o) => parseInt(o.value, 10)).filter(Number.isFinite);
              onChange({ ...data, subject_ids: options });
            }}
            className="border rounded px-2 w-full h-40"
          >
            {subjects?.map((subject) => (
              <option key={subject.id} value={subject.id}>
                {subject.name}
              </option>
            ))}
          </select>
        </div>
        <div className="flex justify-end space-x-2 mt-4">
          <button className="px-3 py-1 rounded bg-gray-300" onClick={onClose}>Cancel</button>
          <button className="px-3 py-1 rounded bg-blue-600 text-white" onClick={onSave}>{mode === 'edit' ? 'Update' : 'Add'}</button>
        </div>
      </div>
    </div>
  );
}
